import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    metaTags: [
      {
        name: "description",
        content: "The home page of portal mieszkanca app."
      },
      {
        property: "og:description",
        content: "The home page of portal mieszkanca app."
      }
    ]
  },
  {
    path: "/messages",
    name: "messages",
    component: () =>
      import(/* webpackChunkName: "messages" */ "../views/Messages.vue")
  },
  {
    path: "/airquality",
    name: "airquality",
    component: () =>
      import(/* webpackChunkName: "airquality" */ "../views/Airquality.vue")
  },
  {
    path: "/waterlevel",
    name: "waterlevel",
    component: () =>
      import(/* webpackChunkName: "waterlevel" */ "../views/Waterlevel.vue")
  },
  {
    path: "/stats/:scords",
    name: "stats",
    component: () =>
      import(/* webpackChunkName: "stats" */ "../views/Stats.vue")
  },
  { path: "/404", component: NotFound },
  { path: "*", redirect: "/404" }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
